<template>
    <div class="container" id="container">
        <header class="outer">
            <div class="wrap" id="nav">
                <img src="../../assets/img/logo.jpg" alt="巴运出行" class="f_l logo">
                <nav class="f_r">
                    <ul class="nav_ul">
                        <li><a :class="position == 'page' ? 'active' : ''" @click="turnPosition('page')">首&nbsp;页</a>
                        </li>
                        <li><a :class="position == 'idDownload' ? 'active' : ''"
                                @click="turnPosition('idDownload')">下载APP</a>
                        </li>
                        <li><a :class="position == 'idProduct' ? 'active' : ''"
                                @click="turnPosition('idProduct')">产&nbsp;品</a></li>
                        <li><a :class="position == 'idAbout' ? 'active' : ''" @click="turnPosition('idAbout')">关于我们</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
        <div id="container_content">
            <section class="m_t_80" id="page">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="swiper-slide-container">
                                <div>
                                    <h3 class="font_50 l_h_70 font_weight_600 color_2B2B2B">巴运出行</h3>
                                    <h3 class="font_50 l_h_70 font_weight_600 color_2B2B2B">全新升级&nbsp;&nbsp;重磅回归</h3>
                                    <p class="color_4A4A4A l_h_30 m_t_18 font_18">
                                        覆盖全国汽车票联网售票、定制客运、网约车、<br />
                                        包租车等多场景出行业务
                                    </p>
                                </div>
                                <div>
                                    <img src="../../assets/img/bn1.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiper-slide-container extra">
                                <div>
                                    <h3 class="font_50 l_h_70 font_weight_600 color_2B2B2B">巴运出行</h3>
                                    <h3 class="font_50 l_h_70 font_weight_600 color_2B2B2B">智能&nbsp;舒适&nbsp;便捷&nbsp;安全
                                    </h3>
                                    <p class="color_4A4A4A l_h_30 m_t_18 font_18">完美解决出行问题&nbsp;让您合理规划行程&nbsp;不再为等车而烦恼
                                    </p>
                                </div>
                                <div>
                                    <img src="../../assets/img/bn2.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiper-slide-container">
                                <div>
                                    <h3 class="font_50 l_h_70 font_weight_600 color_2B2B2B">巴运出行</h3>
                                    <h3 class="font_50 l_h_70 font_weight_600 color_2B2B2B">让出行变得更简单</h3>
                                    <p class="color_4A4A4A l_h_30 m_t_18 font_18">关注巴运出行微信公众号&nbsp;随时随地了解更多出行资讯</p>
                                </div>
                                <div>
                                    <img src="../../assets/img/bn3.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <!-- 如果需要导航按钮 -->
                </div>
            </section>
            <section class="governmentBg_section">
                <a href="https://www.sc.gov.cn" class="governmentBg_link" target="_blank">
                    <img src="../../assets/img/governmentBg.png"></img>
                </a>
            </section>
            <section id="idDownload" class="Download">
                <p class="Download_title">自在旅程&nbsp;&nbsp;&nbsp;&nbsp;一触即发</p>
                <div class="wrap outer">
                    <div class="m_t_60 fr_center small_font">
                        <ul class="down_list">
                            <li class="m_r_20">
                                <div class="markImg"><img src="../../assets/img/weixin.png" alt="二维码"></div>
                                <p>微信公众号</p>
                                <div class="down_list_div">
                                </div>
                            </li>
                            <li class="m_r_20">
                                <div class="markImg"><img src="../../assets/img/wechat.png" alt="小程序"></div>
                                <p>小程序</p>
                                <div class="down_list_div">
                                </div>
                            </li>
                            <li class="m_r_20">
                                <div class="markImg"><img src="../../assets/img/ios.png" alt="二维码"></div>
                                <p>IOS</p>
                                <div class="down_list_div">
                                </div>
                            </li>
                            <li class="m_r_20">
                                <div class="markImg"><img src="../../assets/img/android.png" alt="二维码"></div>
                                <p>安卓</p>
                                <div class="down_list_div">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section id="idProduct" class="bg_FBFBFB h_500">
                <div class="wrap p_tb_44 outer" id="callCar">
                    <div class="f_l">
                        <img src="../../assets/img/onlineCar.png" alt="img">
                    </div>
                    <div class="f_r w_436 m_t_120">
                        <h1 class="font_36 color_4A4A4A l_h_60 m_b_30 font_weight_600">全国汽车票在线购票</h1>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            实时查询车次、在线预订购票
                        </p>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            微信、小程序、APP多渠道购票，出行方便
                        </p>
                    </div>
                </div>
            </section>
            <section class="h_500">
                <div class="wrap  outer">
                    <div class="f_l w_520  m_t_140">
                        <h1 class="font_36 color_4A4A4A l_h_60 m_b_30 font_weight_600">定制客运&nbsp;智能出行</h1>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            商务小车&nbsp;宽敞舒适&nbsp;在线预订&nbsp;就近乘车
                        </p>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            多点上下&nbsp;便捷安全
                        </p>
                    </div>
                    <div class="f_r p_r_60" id="small_width">
                        <img src="../../assets/img/iosCar.png" alt="img">
                    </div>
                </div>
            </section>
            <section class="bg_FBFBFB h_500">
                <div class="wrap  outer" id="callCar">
                    <div class="f_l">
                        <img src="../../assets/img/callCar.png" alt="img">
                    </div>
                    <div class="f_r w_436 m_t_140">
                        <h1 class="font_36 color_4A4A4A l_h_60 m_b_35 font_weight_600">轻触按钮&nbsp;一键叫车</h1>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            即时约车&nbsp;接送一步到位
                        </p>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            优雅穿梭城市&nbsp;享受舒适行程
                        </p>
                    </div>
                </div>
            </section>
            <section id="idProduct" class="bg_f5f5f5 h_500">
                <div class="wrap  outer">
                    <div class="f_l w_520 p_l_40 m_t_140">
                        <h1 class="font_36 color_4A4A4A l_h_60 m_b_35 font_weight_600">个性定制&nbsp;贴心服务</h1>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            多场景包/租车
                        </p>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            团队、家庭出行优选
                        </p>
                        <p class="font_18 l_h_36 color_4A4A4A">
                            随心所欲掌控自己的出行线路
                        </p>
                    </div>
                    <div class="none"></div>
                    <div class="f_r p_r_40 m_t_44" id="small_width">
                        <img src="../../assets/img/serviceCar.png" alt="img">
                    </div>
                </div>
            </section>
            <section id="idAbout" class="h_1039 about_container">
                <div class="wrap p_t_60 p_b_140">
                    <h1 class="text_c font_36  m_b_16">关于我们</h1>
                    <h2 class="text_c font_18  m_b_40">About&nbsp;us</h2>
                    <h2 class="text_c font_18  m_b_16">&lt;品牌背景&gt;</h2>
                    <p class="font_16 l_h_30   m_b_50">
                        巴运出行由四川巴运出行科技服务有限公司所开发的客运出行在线预定软件，为广大社会公众提供移动终端（手机）购票、人工代理网点购票等多项票务服务和相关道路客运信息的发布服务。
                    <h2 class="text_c font_18  m_b_16">&lt;巴运出行APP简介&gt;</h2>
                    <p class="font_16 l_h_30   m_b_50">
                        巴运出行是一个服务于旅客公路客运出行的软件。巴运出行APP平台在实现为乘客线上购票，旅游包车，预约出行，一键式叫车等乘车出行提供更专业、更安全、更便捷、更贴心的一站式出行解决方案及优质出行服务的同时，囊括网络预约出租车、专车、顺风车、代驾、自驾租车服务，更可集成旅游服务、酒店住宿服务等功能，致力发展成为巴中市本土区域内最大的移动互联网综合出行服务APP平台。
                    </p>
                    <h2 class="text_c font_18  m_b_16">&lt;我们的宗旨&gt;</h2>
                    <p class="font_16 l_h_30   m_b_50">
                        公司秉承“智出行，慧生活”的服务理念，主推四大服务功能即:查询购买汽车票、各类包车业务、城际（定制客运）出行网约车业务、城内网约出行业务。将“轻出行”的理念贯穿至人们的日常出行生活之中，将科技与出行完美结合，让用户享受“智慧交通”所带来的红利。
                    </p>
                    <h2 class="text_c font_18  m_b_50">&lt;发展历程&gt;</h2>
                    <div class="developContainer">
                        <img src="../../assets/img/develop.png">
                        </img>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </section>
        </div>
        <footer class="bg_404652 footer_container">
            <div class="wrap p_t_50 p_b_40" id="contact">
                <h1 class="font_16">联系我们</h1>
                <div class="font_14">
                    <!-- <p class="m_b_12 m_t_12 l_h_30">
                        <span class="m_r_90">咨询热线：0827-2558588&nbsp;/&nbsp;0827-2557899 (工作时间09:00-18:00)</span>
                    </p> -->
                    <p class="m_b_12 m_t_12 l_h_30 flex_between">
                        <span>客服电话：400-660-8787</span>
                        <span>联系电话：0827-2558588</span>
                        <span>地 址：四川省巴中市巴州区江北滨河路江北车站大楼三楼</span>
                    </p>
                    <p class="m_b_12 m_t_12 l_h_30 fr_center">
                        Copyright&nbsp;&nbsp;&copy;2020&nbsp;&nbsp;四川巴运出行科技服务有限公司.&nbsp;&nbsp;&nbsp;备案号：<a
                            href="https://beian.miit.gov.cn" target="_blank"
                            class="color_ED7218">蜀ICP备&nbsp;16032721&nbsp;号-1
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
/* swiper版本是5.4.5 */
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入
export default {
    components: {
        Swiper,
    },
    data() {
        return {
            position: 'page',
            bodyHeight: 0,
            page_top: 0,
            idDownload_top: 0,
            idProduct_top: 0,
            idAbout_top: 0,
        };
    },
    computed: {},
    watch: {},
    methods: {
        turnPosition(id) {
            let anchorElementHeight = document.getElementById(id).offsetTop;   // 要跳转元素到offsetParent顶部的距离
            let navBar = 80;  //固定头部的高度;
            window.scrollTo({
                top: anchorElementHeight - (navBar),
                behavior: "smooth"
            });
        },
        initSwiper() {
            new Swiper('.swiper-container', {
                direction: 'horizontal', // 垂直切换选项
                loop: true, // 循环模式选项
                // autoplay: true, // 自动滑动
                autoplay: { disableOnInteraction: false },
                speed: 800,
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
        },
        scroll() {
            this.bodyHeight = document.documentElement.scrollTop || document.body.scrollTop;
            console.log(this.bodyHeight, this.idAbout_top, this.idProduct_top, this.idDownload_top);
            this.$nextTick(() => {
                if (this.bodyHeight >= this.idAbout_top - 120) {
                    this.position = 'idAbout';
                } else if (this.bodyHeight >= this.idProduct_top - 120) {
                    this.position = 'idProduct';
                } else if (this.bodyHeight >= this.idDownload_top - 120) {
                    this.position = 'idDownload';
                } else {
                    this.position = 'page';
                }
            }, 200)
        }
    },
    created() {
    },
    mounted() {
        this.initSwiper();
        this.page_top = document.getElementById('page').offsetTop;
        this.idDownload_top = document.getElementById('idDownload').offsetTop;
        this.idProduct_top = document.getElementById('idProduct').offsetTop;
        this.idAbout_top = document.getElementById('idAbout').offsetTop;
        window.addEventListener('scroll', this.scroll);

    },
    beforeCreate() { },
    beforeMount() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
    activated() { },
}
</script>
<style  scoped>
@import url('../../assets/css/main.css');

.container {
    background-color: white;
}

header.outer {
    background-color: #FFFAF7;
}

.swiper-container {
    width: 100%;
    height: 600px;
    background-color: #FFFAF7;
}

.Download_title {
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2B2B2B;
    line-height: 33px;
    font-weight: 600;
    /* padding-top:80px; */

}

.fr_center {
    text-align: center;
}

.about_container {
    background-image: url('../../assets/img/bg.png');
    background-repeat: no-repeat;
    background-color: white;
    color: white;
}

.footer_container {
    color: white;
}

.swiper-slide-container {
    display: flex;
    justify-content: space-between;
    margin: 106px 24% 0;
}

.swiper-slide-container.extra {
    display: flex;
    justify-content: space-between;
    margin: 163px 18% 0;
}

.font_weight_600 {
    font-weight: 600;
}

.Download {
    height: 473px;
    padding-top: 10px;
    box-sizing: border-box;
}

.nav_ul>li {
    cursor: pointer;
}

.developContainer {
    text-align: center;
}

.flex_between {
    display: flex;
    justify-content: space-between;
}

.governmentBg_section {
    margin-top: 40px;
    margin-bottom: 30px;
    text-align:center;
}
.governmentBg_link {
    /* width:100%; */
    /* display:block; */
    margin:0 auto;
}
.governmentBg_section img {
    /* width: 100%; */
     margin:0 auto;
    background-repeat: no-repeat;
    background-size: 100%;

}
</style>


// WEBPACK FOOTER //
// src/bycx/views/homePage/index.vue